import React from 'react';
import {useSelector} from "react-redux";

const LoaderIcon = props => {
    const isLoading = useSelector(state => state.ajaxState.loading);

    return (
        <div className={"sb-loading-overlay" + (isLoading ? " show" : "") }>
            <div className="sb-loading-icon-backdrop" />
            <div className="sb-loading-icon-container">
                <div className="sk-folding-cube">
                    <div className="sk-cube1 sk-cube"></div>
                    <div className="sk-cube2 sk-cube"></div>
                    <div className="sk-cube4 sk-cube"></div>
                    <div className="sk-cube3 sk-cube"></div>
                </div>
            </div>
        </div>
    );
};

export const StreamBankLoaderIconDisplayEnhance = (ComposedComponent) => function StreamBankLoaderIconDisplayEnhance(props) {
    return <div>
        <LoaderIcon />
        <ComposedComponent {...props} />
    </div>;
};
